<template>
    <v-content>
        
        <v-breadcrumbs :items="breadCrumbs" large></v-breadcrumbs>
        <v-dialog max-width="1000px" v-model="dialogRow">
            <RowComponent :key="count" :logResponseData="logData" @formResponse="onResponse"></RowComponent>
        </v-dialog>
        <v-dialog max-width="500px" v-model="dialogSettings">
            <SettingsComponent :key="componentKey" @formResponse="onResponse" />
        </v-dialog>
        <ReportComponent :ApiData="apiDataReport" @logDataResponse="getResponseLogData"></ReportComponent>
    </v-content>
</template>

<script>
    import ReportComponent from "./ReportComponent";
    import SettingsComponent from "./SettingsComponent";
    import RowComponent from "./RowComponent";
    import axios from "axios";

    export default {
        name: 'ReportList',
        components: {
            ReportComponent,
            SettingsComponent,
            RowComponent
        },
        data() {
            return {
                count: 0,
                reportName: '',
                reportID: this.$route.params.id,
                getInfo: JSON.parse(this.$store.getters.getInfo),
                componentKey: 0,
                direction: 'bottom',
                fab: false,
                fling: false,
                hover: false,
                tabs: null,
                top: true,
                right: true,
                transition: 'slide-y-transition',
                dashboardItems: [

                    {
                        name: "Add Headers",
                        link: `/header/${this.$route.params.id}`
                    },
                ],
                apiData: [],
                apiDataReport: [],
                dialogSettings: false,
                dialogRow: false,
                reportList: [],
                yearList: ["2020-2019", "2019-2018", "2018-2017", "2017-2016", "2016-2015", "2015-2014", "2014-2013", "2013-2012", "2012-2011",],
                logData: [],

            };
        },
        mounted() {
            this.loadData()
        },
        computed: {
            breadCrumbs() {
                return [
                    {
                        text: this.$t('dashboard'),
                        disabled: false,
                        to: `${this.userData.dashBoardBranchUser}`,
                        exact: true

                    },
                    {
                        text: this.$t('actualReport'),
                        disabled: false,
                        to: '/actualReport',
                        exact: true
                    },
                    {
                        text: this.reportName,
                        disabled: true,
                    }
                ]
            }
        },
        methods: {
            getResponseLogData(val) {
                this.logData = val
            },
            rowModal() {
                this.count++
                this.dialogRow = true
            },
            settings() {
                //to re render components
                this.dialogSettings = true
                this.componentKey++
            },
            onResponse(data) {
                console.log(data);
                this.dialogSettings = false
                this.dialogRow = false
            },

            loadData() {

                let reportID = this.$route.params.id;
                axios.get('ReportSettings/DDLReportList').then(response => {
                    this.reportList = response.data
                    const report = response.data.find(({ id }) => id == reportID);
                    this.reportName = report.value;


                })

            },


            nullTitle(title) {
                return title == null
            },
        }
    };
</script>

<style lang="scss" scoped>

    .v-sheet--offset {
        top: -24px;
        position: relative;
    }

    .tbl th {
        padding-top: 12px;
        padding-bottom: 12px;
        text-align: left;
        background-color: $main-color;
        color: white;
    }

    table, td, th {
        border: 1px solid #ddd;
        text-align: left;
    }

    table {
        border-collapse: collapse;
        width: 100%;
    }

    th, td {
        padding: 15px;
    }

    a {
        text-decoration: none;
        color: black;
    }

    .v-list-item {
        &:hover {
            background: #e6d8d84d;
        }
    }
    .top_headers{
        text-align: end;
    }
    a{
        color: white;
    }
</style>
